import React from 'react';
import { motion } from 'framer-motion';
import { useTheme } from '../../context/ThemeContext';

const StepCard = ({ number, title, description }) => {
  const { isDarkMode } = useTheme();
  
  return (
    <motion.div 
      className="relative p-[1px] rounded-[20px] group cursor-pointer"
      style={{
        background: isDarkMode 
          ? 'linear-gradient(90deg, #FCD239 0%, #FCD239 80%, #000000 100%)'
          : 'linear-gradient(90deg, #FCD239 0%, #FCD239 80%, #FFFFFF 100%)'
      }}
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
    >
      <div 
        className={`h-full w-full rounded-[20px] p-8 ${
          isDarkMode ? 'bg-[#000000]' : 'bg-white'
        } transition-all duration-500 ease-in-out relative overflow-hidden`}
      >
        {/* Hover gradient overlay */}
        <div 
          className="absolute inset-0 opacity-0 group-hover:opacity-100 transition-all duration-700 ease-in-out"
          style={{
            background: isDarkMode 
              ? 'linear-gradient(90deg, #FEF4D7 0%, #FEF4D7 75%, #000000 100%)'
              : 'linear-gradient(90deg, #FEF4D7 0%, #FEF4D7 75%, #FFFFFF 100%)'
          }}
        />

        {/* Content */}
        <div className="flex items-center gap-8 relative z-10 min-h-[120px]">
          {/* Number on the left */}
          <div className="flex-shrink-0">
            <span 
              className="text-[80px] font-bold bg-gradient-to-r from-[#FCD535] to-[#F49097] bg-clip-text text-transparent font-bricolage"
              style={{ lineHeight: 'auto', letterSpacing: '0%' }}
            >
              {number}
            </span>
          </div>

          {/* Content on the right */}
          <div className="flex-1 flex flex-col justify-center">
            <h3 className={`text-[26px] font-semibold mb-2 ${
              isDarkMode ? 'text-white' : 'text-black'
            } font-lexend tracking-[0%] leading-[auto] transition-all duration-500 ease-in-out group-hover:text-black`}>
              {title}
            </h3>
            <p className={`text-[18px] font-light ${
              isDarkMode ? 'text-white' : 'text-black'
            } font-lexend tracking-[0%] leading-[auto] transition-all duration-500 ease-in-out group-hover:text-black`}>
              {description}
            </p>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

const HowItWorksSection = ({ steps }) => {
  const { isDarkMode } = useTheme();

  return (
    <section className={`py-16 ${isDarkMode ? 'bg-[#000000]' : 'bg-white'}`}>
      <div className="max-w-[1300px] mx-auto px-4 sm:px-6 lg:px-8">
        <motion.h2 
          className={`text-[32px] sm:text-[36px] font-medium text-center mb-12 ${
            isDarkMode ? 'text-white' : 'text-black'
          } font-lexend`}
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
        >
          How it works
        </motion.h2>

        <div className="flex flex-col space-y-4">
          {steps.map((step, index) => (
            <StepCard
              key={index}
              number={index + 1}
              title={step.title}
              description={step.description}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HowItWorksSection; 